import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { VideoFile } from "@models/video-file";
import {
  deleteRequest,
  fetchRequest,
  createRequest,
  updateRequest
} from "@actions/video-file";
import VideoFileForm from "@components/video-files/Form";
import videoFileApi from "@api/video-file";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: VideoFile[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class VideoFileFormPage extends React.Component<AllProps> {
  state = {
    videoFile: null,
    videoFile_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.videoFile_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    videoFileApi
      .getItem({
        params: {
          id: this.state.videoFile_id
        }
      })
      .then(({ data }) => {
        this.setState({
          videoFile: data
        });
      })
      .catch(error => console.log(error));
  };

  getFile = () => {
    if (this.state.videoFile_id && !this.state.videoFile) {
      return null;
    }

    return (
      <VideoFileForm
        videoFile={this.state.videoFile || {}}
        intl={this.props.intl}
        listUrl={"/video-files"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getFile()}</Fragment>;
  }
}

const mapStateToProps = ({ videoFiles }: ApplicationState) => ({
  loading: videoFiles.loading,
  errors: videoFiles.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(VideoFileFormPage));
